/**
 * small: 16
 * medium: 24
 * large: 32
 * exLarge: 48
 */

import { TypographySxProps } from '../sx'

export const sizeToFontSize = (
  size?: 'small' | 'medium' | 'large'
): TypographySxProps['fontSize'] => {
  switch (size) {
    case 'large':
      return 32
    case 'medium':
      return 24
    case 'small':
      return 16
    default:
      return 24
  }
}
